// Auto-generated by scripts/sync-icons.ts. Do not edit by hand.
// Source: react-icons/hi -> HiXCircle
import type { IconBaseProps } from "..";

export function HiXCircle({ size, color, style, ...rest }: IconBaseProps) {
  const computedStyle = color ? { color, ...style } : style;
  const dim = size ?? "1em";
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      viewBox="0 0 20 20"
      aria-hidden="true"
      width={dim}
      height={dim}
      {...rest}
      style={computedStyle}
    >
      <path
        fillRule="evenodd"
        d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
        clipRule="evenodd"
      />
    </svg>
  );
}
